// extracted by mini-css-extract-plugin
export default {"tableWrapper":"associated-services_tableWrapper__PYtuu"};